import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { getProduct } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
import { Stars } from '../shop/Stars';
const roles = ['Reinigen', 'Scrubben', 'Behandelen', 'Opfrissen', 'Voeden'];
export function RitualSetFeature() {
  const {
    add
  } = useCart();
  const set = getProduct('hammam-ritueel-set');
  if (!set) return null;
  const variant = set.variants[0];
  const items = (set.includes ?? []).map(slug => getProduct(slug)).filter(Boolean);
  return <section className="bg-surface" data-id="element-95" data-mp="jq5bwg6d11df">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24" data-id="element-96" data-mp="jr84csjbzbvg">
        <img src={set.image} alt="De Hammam Ritueel Set met zwarte zeep, kessa, klei, rozenwater en arganolie" className="aspect-square w-full rounded-3xl object-cover" data-id="element-97" data-mp="nqgyhyia9brj" />

        <div className="flex flex-col justify-center" data-id="element-98" data-mp="xpeqxcitxpft">
          <Stars rating={set.rating} reviews={set.reviews} size="md" data-id="element-99" data-mp="xnu09xzmyqn8" />
          <h2 className="mt-4 text-4xl font-semibold tracking-display text-ink sm:text-5xl" data-id="element-100" data-mp="2fvoc6zzv0erd">Het complete ritueel in één doos</h2>
          <p className="mt-4 max-w-lg text-lg text-muted" data-id="element-101" data-mp="2axwn0dqln6qv">
            Vijf producten, in de volgorde waarin je ze gebruikt. Zo weet je precies wat je doet — en waarom.
          </p>

          <ol className="mt-8 divide-y divide-line border-y border-line" data-id="element-102" data-mp="21wyg9nos0l4l">
            {items.map((p, i) => p ? <li key={p.slug} data-id="element-103" data-mp="2ujrikahtdsgp">
                  <Link to={`/product/${p.slug}`} className="group flex items-center gap-4 py-3" data-id="element-104" data-mp="2uku9ujj1twx5">
                    <span className="w-5 text-sm font-medium text-muted tabular-nums" data-id="element-105" data-mp="2ps14btfrakk0">{i + 1}</span>
                    <span className="w-28 text-sm text-muted" data-id="element-106" data-mp="2kswxh9gb0ywu">{roles[i]}</span>
                    <span className="flex-1 font-medium text-ink group-hover:underline group-hover:underline-offset-4" data-id="element-107" data-mp="3i9vnqmani09t">{p.name}</span>
                  </Link>
                </li> : null)}
          </ol>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-4" data-id="element-108" data-mp="aszz6wt4tto">
            <p data-id="element-109" data-mp="58uinqqbmr4m">
              <span className="text-3xl font-semibold tracking-tight" data-id="element-110" data-mp="57jie0w341i9">{formatPrice(variant.price)}</span>
              {variant.compareAt && <>
                  <span className="ml-2 text-muted line-through" data-id="element-111" data-mp="3rnxhpbwbz8st">{formatPrice(variant.compareAt)}</span>
                  <span className="ml-3 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-clay" data-id="element-112" data-mp="3dnv1du3o8nfo">
                    Bespaar {formatPrice(variant.compareAt - variant.price)}
                  </span>
                </>}
            </p>
          </div>
          <div className="mt-6 flex flex-wrap gap-3" data-id="element-113" data-mp="34q2k4kee35pn">
            <button onClick={() => add(set.slug, variant.id)} className="inline-flex h-14 items-center whitespace-nowrap rounded-full bg-ink px-8 text-base font-medium text-canvas transition-colors duration-150 hover:bg-clay" data-id="element-114" data-mp="38qcsu4tkga87">
              In winkelwagen
            </button>
            <Link to={`/product/${set.slug}`} className="inline-flex h-14 items-center whitespace-nowrap rounded-full border border-ink/15 bg-white px-7 text-base font-medium text-ink transition-colors duration-150 hover:border-ink" data-id="element-115" data-mp="2rgihqfa3aqw0">
              Bekijk de set
            </Link>
          </div>
        </div>
      </div>
    </section>;
}